import { Box, Tab, Tabs, styled } from "@mui/material";
import styles from "./index.module.scss";
import React, { useEffect, useRef, useState } from "react";
import { KPI_TAB_STATUSES } from "../../../constants";

type TabsComponentProps = {
  handleTabChange: (value: number, label: string) => void;
  tabsData: { count: number; status: string }[];
  activeTab?: number;
  setActiveTab?: (value: number) => void;
  className?: string;
  sessions?: any[]; // Assuming sessions is an array, adjust type as needed
  role: string;
  totalRecords?: number; // Optional prop for total records
};

const StyledTab = styled(Tabs)(() => ({
  ".MuiTabs-scroller": {
    height: "60px",
  },
  ".MuiTabs-flexContainer": {
    // gap: "5px",
    height: "60px",
    paddingLeft: "17px",
    //  paddingTop:"12px",
    display: "flex",
    alignItems: "center",
    boxshadow:
      "inset -10px 0 10px -5px rgba(255, 255, 255, 0.5), inset 10px 0 10px -5px rgba(255, 255, 255, 0.5)",
  },
  ".MuiTabs-root": {
    minHeight: "60px !important",
    padding: "5px 5px",
  },
  "MuiButtonBase-root-MuiTab-root": {
    padding: "0",
  },
  ".Mui-disabled": {
    display: "none",
  },
  ".MuiTabs-scrollButtons": {
    border: "1.5px solid black",
    borderRadius: "50%",
    margin: "12px 14px 0px 14px",
    width: "35px",
    height: "30px",
  },
  ".css-ptiqhd-MuiSvgIcon-root ": {
    fontSize: "30px",
    fontWeight: "200",
  },
  ".MuiSvgIcon-root ": {
    fill: "black",
  },
  ".MuiTabs-indicator": {
    backgroundColor: "#1859B4",
    height: "3px",
    border: "unset",
  },

  ".MuiButtonBase-root": {
    // padding: "10px 16px",
    textTransform: "capitalize",
    height: "36px",
  },
  ".css-1h9z7r5-MuiButtonBase-root-MuiTab-root": {
    color: "#051B46",
    fontSize: "14px",
    fontStyle: " normal",
    fontWeight: "400",
    lineHeight: "24px",
  },
  ".css-1h9z7r5-MuiButtonBase-root-MuiTab-root.Mui-selected ": {
    color: "#051B46",
    fontSize: "14px",
    fontStyle: " normal",
    fontWeight: "600",
    lineHeight: "24px",
  },

  ".MuiTabScrollButton-horizontal": {},
}));

const AdminKpiData: React.FC<TabsComponentProps> = ({
  handleTabChange,
  tabsData = [],
  activeTab = 0,
  setActiveTab,
  className,
  sessions = [],
  role,
  totalRecords
}) => {
  const [scrollLeft, setScrollLeft] = useState(false);
  const tabsRef = useRef<HTMLDivElement>(null);
  const [scrollRight, setScrollRight] = useState(true);

  const defaultTabsData = [
    { count: 0, status: KPI_TAB_STATUSES.TOTAL_REGISTRATIONS },
    { count: 0, status: KPI_TAB_STATUSES.VIDEO },
    { count: 0, status: KPI_TAB_STATUSES.NON_VIDEO },
    { count: 0, status: KPI_TAB_STATUSES.DOWNGRADED },
    { count: 0, status: KPI_TAB_STATUSES.BULK_REGISTRATIONS },
  ];

  let effectiveTabsData;

  if (role === "mahatria") {
    effectiveTabsData = (sessions?.length ? sessions : defaultTabsData).map(
      (tab) => {
        const session = sessions.find(
          (s: any) => s.id === tab.id || s.name === tab.status,
        );
        return {
          ...tab,
          count:
            session && typeof session.allocatedCount === "number"
              ? session.allocatedCount
              : tab.count,
          status: session && session.name ? session.name : tab.status,
        };
      }
    );
    effectiveTabsData.unshift({
      count: totalRecords || 0,
      status: "Registered",
    });
  } else if (role === "admin") {
    effectiveTabsData = tabsData?.length ? tabsData : defaultTabsData;
  }

  console.log("effectiveTabsData", effectiveTabsData);

  const handleScroll = () => {
    if (tabsRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = tabsRef.current;
      setScrollLeft(scrollLeft > 0);
      setScrollRight(scrollLeft + clientWidth < scrollWidth);
    }
  };

  useEffect(() => {
    const ref = tabsRef.current;
    if (ref) {
      handleScroll();
      ref.addEventListener("scroll", handleScroll);
      return () => {
        ref.removeEventListener("scroll", handleScroll);
      };
    }
  }, [tabsRef]);

  return (
    <div
      className={className ? styles.className : styles.KPIContainer}
      data-testid="admin-kpi-data"
    >
      <Box
        sx={{
          maxWidth: { xs: "100%", sm: "100%", md: "100%", lg: "100%" },
          bgcolor: "background.paper",
          border: "1px solid #E7EEF3",
          padding: "0px",
          height: "60px",
          borderRadius: "8px",
        }}
      >
        <StyledTab
          className={`${scrollLeft ? styles.scrollLeft : ""} ${scrollRight ? styles.scrollRight : ""
            }`}
          variant="scrollable"
          ref={tabsRef}
          value={activeTab}
          onChange={(event, newValue) => {
            if (typeof setActiveTab === "function") {
              setActiveTab(newValue);
            }
            if (newValue < effectiveTabsData.length) {
              const selectedTab = effectiveTabsData[newValue];
              handleTabChange(selectedTab.count, selectedTab.status);
            }
          }}
        >
          {effectiveTabsData.map((item, index) => (
            <Tab
              key={index}
              data-testid={`tab-${index}`}
              selected={activeTab === index}
              label={
                <span>
                  <span
                    className={styles.kpiCount}
                    data-testid={`kpi-count-${index}`}
                  >
                    {item?.count < 10 ? `0${item?.count}` : item?.count}
                  </span>
                  <span
                    className={`${styles.kpiName} ${activeTab === index ? styles.activeKpiName : ""
                      }`}
                    data-testid={`kpi-name-${index}`}
                  >
                    {item?.status}
                  </span>
                </span>
              }
            />
          ))}
        </StyledTab>
      </Box>
    </div>
  );
};

export default AdminKpiData;
